import _get from 'lodash/get';
import { SsoIntegrationProviderPresetEnum } from 'graphql-common';
import { Values } from '@lib/interfaces/form';
import { SsoIntegrationFieldNames } from './constants';

export default function isCustomPreset(values: Values): boolean {
  return (
    _get(values, [SsoIntegrationFieldNames.ProviderPreset, 'value']) ===
    SsoIntegrationProviderPresetEnum.Custom
  );
}
